import { ZodSchema, z } from 'zod';
import { Combinator, CompleteQuery } from 'modules/queryBuilder/types';
import { useSegmentationCriteriaSchema } from './useSegmentationCriteriaSchema';

export const useSegmentationQuerySchema = () => {
  const segmentationCriteriaSchema = useSegmentationCriteriaSchema();
  return z.object({
    combinator: z.nativeEnum(Combinator),
    searchQueries: z.array(segmentationCriteriaSchema),
  }) as ZodSchema<CompleteQuery>;
};
